import { BaseModal, Input } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import React, { useMemo, useState } from 'react';
import { formatDate, formatTime } from 'utils/functions';

const OrderLogsModal = ({
  showModal,
  setShowModal,
  order
}: {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  order: OrderType;
}) => {
  const [searchValue, setSearchValue] = useState('');

  const orderLogs = useMemo(() => {
    if (searchValue) {
      return (
        order.order_logs.filter(
          (log) =>
            log.action.toLowerCase().includes(searchValue.toLowerCase()) ||
            log.metadata?.performed_by?.first_name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            log.metadata?.performed_by?.last_name.toLowerCase().includes(searchValue.toLowerCase())
        ) || []
      );
    } else {
      return order.order_logs;
    }
  }, [searchValue, order]);

  return (
    <BaseModal
      isOpen={showModal}
      onRequestClose={() => {
        setShowModal(false);
      }}
      title='Order Logs'>
      <div>
        <Input
          small
          placeholder='Search by action or user name'
          className='w-full mb-1'
          onChange={(e) => setSearchValue(e.target.value)}
        />

        <ul>
          {orderLogs?.map((log) => (
            <li key={log.id} className='flex justify-between items-center py-3 px-2'>
              <div>
                <p className='capitalize'> {log.action.split('_').join(' ')}</p>
                {log.metadata?.performed_by ? (
                  <p className='text-sm font-medium text-gray-4'>
                    By&nbsp;
                    <strong>
                      {log.metadata.performed_by.first_name} {log.metadata.performed_by.last_name}
                    </strong>
                  </p>
                ) : (
                  <p className='text-sm font-medium text-gray-4'>{log.metadata?.description}</p>
                )}
              </div>
              <div>
                <p className='text-xs text-gray-600 text-right'>
                  {formatDate(log.created_at)}
                  <br />
                  {formatTime(log.created_at)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </BaseModal>
  );
};

export default OrderLogsModal;
